
import { useEffect, useRef } from 'react'

import { createPortal } from 'react-dom'
import styled from 'styled-components'

import {
    IconOptionsPlaylist,
    IconOptionsReport,
    IconOptionsThrash,
} from 'assets/svg/sprite'
import AddToPlaylist from 'components/UI/Modal/AddToPlaylist/AddToPlaylist'
import { useModalContext } from 'context/modalContext'
import screens from 'styles/screens'

interface MessageOptionsDropdownProps {
    isOpen: boolean
    setIsOpen: (value: boolean) => void
    onDelete: () => void
    onReport: () => void
    recieved?: boolean
    messageId: string
    hasMedia?: boolean
}
export const MessageOptionsDropdown = ({
    isOpen,
    setIsOpen,
    onDelete,
    onReport,
    recieved = false,
    messageId,
    hasMedia = false,
}: MessageOptionsDropdownProps) => {
    const optionsRef = useRef<HTMLDivElement>(null)
    const modalContext = useModalContext()
    useEffect(() => {
        if (!isOpen) return

        const handlePointerDown = (event: MouseEvent | TouchEvent) => {
            const target = event.target as Node | null
            if (!target) return

            if (optionsRef.current?.contains(target)) return

            setIsOpen(false)
        }

        document.addEventListener('mousedown', handlePointerDown)
        document.addEventListener('touchstart', handlePointerDown)

        return () => {
            document.removeEventListener('mousedown', handlePointerDown)
            document.removeEventListener('touchstart', handlePointerDown)
        }
    }, [isOpen, setIsOpen])

    if (!isOpen) return null

return createPortal(
  <>
    <BackgroundContainer onClick={() => setIsOpen(false)} />

    <div className="post__options">
      <OptionsDropdownWrapper ref={optionsRef}>
        <div className="post__options__dropdown__section">
        {hasMedia && (
            <div
                className="post__options__option"
                onClick={() => {
                    setIsOpen(false)

                    modalContext.addModal(
                        '',
                        <AddToPlaylist
                            itemId={messageId}
                            itemType="message"
                            closeFn={() => modalContext.clearModal()}
                        />,
                        true,
                        true
                    )
                }}
            >
                <IconOptionsPlaylist />
                <span>Add To List</span>
            </div>
        )}

          <div
            className="post__options__option"
            onClick={() => {
              setIsOpen(false)
              onDelete()
            }}
          >
            <IconOptionsThrash />
            <span>
              {recieved ? 'Hide Message' : 'Delete Message'}
            </span>
          </div>

          {recieved && (
            <div
              className="post__options__option"
              onClick={() => {
                setIsOpen(false)
                onReport()
              }}
            >
              <IconOptionsReport />
              <span>Report Message</span>
            </div>
          )}
        </div>
      </OptionsDropdownWrapper>
    </div>
  </>,
  document.body
)
}

const BackgroundContainer = styled.div`
  position: fixed;
  inset: 0;
  z-index: 999998;
  background: transparent;
`

const OptionsDropdownWrapper = styled.div`
  position: fixed;
  z-index: 999999;

  background: #fff;

  width: calc(100% - 3.2rem);
  max-width: 500px;
  transform: translate3d(0, 100%, 0);
  height: auto !important;
  min-height: 0 !important;
  max-height: calc(100dvh - 3.2rem);
  transition:
    transform 0.1s ease-in-out,
    visibility 0.1s ease-in-out;

  overflow-y: auto;

  padding: 3rem 0;

  border-radius: 2.5rem;

  box-shadow: 0 2rem 6rem rgba(17, 29, 41, 0.35);

  top: 50%;
  left: 50%;
  right: auto;
  bottom: auto;

  transform: translate(-50%, -50%);

  @media (max-width: ${screens.medium}) {
    top: auto;
    left: 0;
    right: 0;
    bottom: 0;

    width: 100%;
    max-width: none;

    transform: none;

    border-radius: 2.5rem 2.5rem 0 0;
    box-shadow: 0 -20px 40px rgba(17, 29, 41, 0.1);
  }
`